// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1eb4l","imageUploader":"EGiftCard_imageUploader__3B-Tj"};